import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/api';

interface Props {
  children: React.ReactNode;
  requireFamily?: boolean; // 是否要求有家庭，默认 true
}

export default function ProtectedRoute({ children, requireFamily = true }: Props) {
  const { isAuthenticated, families } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
      return;
    }
    if (requireFamily && families.length === 0) {
      navigate('/welcome', { replace: true });
    }
  }, [isAuthenticated, families, requireFamily, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  if (requireFamily && families.length === 0) {
    return null;
  }

  return <>{children}</>;
}
